import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, Headers } from '@angular/http';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { IbRequest } from '../ib-request';
import {IbResponse} from '../ib-response';



const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class DataService {

  // private baseUrl = 'http://10.101.10.122:8090/Angular2WebserviceForLogin/';
  private baseUrl: string = 'http://10.101.10.109:9097/InternetBankingServer/';
  private storedUserName: string = '';
  private token = '';
  constructor(private http: HttpClient) { }

 /* login(post): Observable<any> {

this.storedUserName =sessionStorage.getItem('storedUserName');
    this.token =sessionStorage.getItem('token');
     const httpPostOptions = {
      headers: new HttpHeaders(
        {
          'Content-Type': 'application/json'
        }),
      withCredentials: true,
    };
    const postLoginUrl = this.baseUrl + 'login/' + post['username'] + '/' + post['password'];
    return this.http.post<IbResponse>(this.baseUrl + URL + '?token=' + this.token + '&param=' + this.storedUserName, Request, httpPostOptions)
      .map(res => {
        console.log(URL + ' : ' + JSON.stringify(res));
        if (res.status === 'success') {
         sessionStorage.setItem('currentUser', JSON.stringify(res));
        }
        return res;
      },
      err => {
        return err;
      }).catch(this.errorHandler);

  }

    getResponse(request: IbRequest, url: string): Observable<IbResponse> {
    this.storedUserName =sessionStorage.getItem('storedUserName');
    this.token =sessionStorage.getItem('token');
    console.log('storedUserName : ' + this.storedUserName + ', token : ' + this.token);
    const httpPostOptions = {
      headers: new HttpHeaders(
        {
          'Content-Type': 'application/json'
        }),
      withCredentials: true,
    };
    if (this.storedUserName === null) {
      return this.http.post<IbResponse>(this.baseUrl + url, request, httpPostOptions).map(response => {
        console.log(url + ' : ' + JSON.stringify(response));
        if (response.status === 'S101') {
          alert('Malicious Request Detected');
          return null;
        } else {
          return response;
        }
      }, error => {
        console.log(url + ' : ' + JSON.stringify(error));
        return error;
      }).catch(this.errorHandler);
    } else {
      return this.http.post<IbResponse>(this.baseUrl + url + '?token=' + this.token + '&param=' + this.storedUserName, request, httpPostOptions).map(response => {
        console.log(url + ' : ' + JSON.stringify(response));
        if (response.status === 'S101') {
          alert('Malicious Request Detected');
          return null;
        } else {
          return response;
        }
      }, error => {
        console.log(url + ' : ' + JSON.stringify(error));
        return error;
      }).catch(this.errorHandler);
    }
  }

  errorHandler(error: HttpErrorResponse): ErrorObservable {
    return Observable.throw(error.message || 'Server Error');
  }*/

  /*logout() {

   sessionStorage.removeItem('currentUser');
  }*/



}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/service/data.service.ts